import { Core } from "@faire/design-tokens";
import { Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";
import styled from "styled-components";

import { Breadcrumb } from "@faire/retailer/components/Breadcrumb";
import { RetailerFooter } from "@faire/retailer/components/Footer/RetailerFooter";
import { Banner } from "@faire/retailer/features/MerchandisedCollection/Components/Banner";
import { Content } from "@faire/retailer/features/MerchandisedCollection/Components/Content";
import { useMerchanisedCollection } from "@faire/retailer/features/MerchandisedCollection/useMerchandisedCollection";

export const MerchandisedCollection: React.FC = () => {
  const {
    merchandisedCollection,
    isLoading,
    isError,
    breadcrumbOptions,
    requestId,
  } = useMerchanisedCollection();

  if (isLoading) {
    return null;
  }

  if (isError) {
    return (
      <Wrapper>
        <Spacer size="3x" />
        <Typography
          color={Core.text.critical}
          align="center"
          variant="displayLSerifRegular"
        >
          Failed to load Merchandised Collection!
        </Typography>
      </Wrapper>
    );
  }

  return (
    <>
      <Wrapper>
        <StyledBreadcrumb options={breadcrumbOptions} dataTestId="breadcrumb" />
        <Banner
          collection={merchandisedCollection}
          dataTestId="merchandised-collection-banner"
        />
        <Content collection={merchandisedCollection} requestId={requestId} />
      </Wrapper>
      <RetailerFooter />
    </>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: auto;
  width: 100%;
  max-width: 1280px;
`;

const StyledBreadcrumb = styled(Breadcrumb)`
  align-self: center;
  max-width: 1280px;
  width: 100%;
  padding-left: 48px;
  padding-right: 48px;

  &&& {
    ${responsiveMediaQueries.mobile} {
      display: none;
    }
  }
`;
